export default __webpack_public_path__ + "static/media/grafema_f1rst_04.c9d431d3.jpg";